import { Type } from "@shared/ui/Type";
import { ProgramPhase, MeetingRole } from "@platform/types/platform.types";
import { SupportArticleListContainer } from "@platform/features/support/components/SupportArticleList/SupportArticleListContainer";
import { TwoColumnsLayout } from "@shared/ui/TwoColumnsLayout";
import { ProgramPhaseActionList } from "../ProgramPhaseAction/ProgramPhaseActionList";
import { ProgramMeetingRoleBadge } from "../ProgramMeetingRoleBadge/ProgramMeetingRoleBadge";
import Button from "@shared/ui/Button";

type Props = {
  phase: ProgramPhase;
  currentPhase: ProgramPhase;
  isLoading: boolean;
  role: MeetingRole | null;
  isPhaseInScheduledEngagement: boolean;
  onMeetingInformationClick: () => void;
};

export function ProgramPhaseItem({
  phase,
  currentPhase,
  isLoading,
  role,
  isPhaseInScheduledEngagement,
  onMeetingInformationClick,
}: Props) {
  return (
    <div className="flex flex-col gap-6 min-w-full">
      <div className="flex flex-col gap-1">
        <Type variant="h4">{phase.name}</Type>
        <Type variant="body2" className="max-w-xl">
          {phase.description}
        </Type>
        <div className="flex flex-col gap-2 md:flex-row ">
          {role && (
            <div className="flex flex-row gap-0.5">
              <Type variant="body2">Your role this week:</Type>
              <ProgramMeetingRoleBadge role={role} badgeClassName="ml-1" />
            </div>
          )}
          {isPhaseInScheduledEngagement && (
            <Button
              variant="link-inline"
              className="px-0 inline-block underline"
              typeVariant="body2"
              onClick={onMeetingInformationClick}
            >
              All roles for this week.
            </Button>
          )}
        </div>
      </div>
      <TwoColumnsLayout layout="wide-left">
        <ProgramPhaseActionList
          actions={phase.actions}
          isCurrentPhase={currentPhase.id === phase.id}
          isLoading={isLoading}
        />

        <SupportArticleListContainer
          title="Related FAQs"
          articles={phase.resources?.articles}
        />
      </TwoColumnsLayout>
    </div>
  );
}

export default ProgramPhaseItem;
